/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import { Col, Row, Space, Radio } from 'antd'
import { numberWithComma } from 'helpers/format'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import ConfirmWithChild from 'Components/modal/ConfirmWithChild'
import { AppInput } from 'Components/form'
import { GrnData } from 'Store/grn/types'
import ConfirmPayDept from './confirm_paydept'
import { cloneDeep } from 'lodash'

type Props = {
  visible: boolean
  onCloseModal: () => void
  onConfirm?: (amount: number) => void
  depy_amount?: number
  grn?: GrnData
}

const AmountPayDept: React.FunctionComponent<Props> = props => {
  const { onCloseModal, visible, onConfirm = () => {}, depy_amount = 0, grn } = props
  const [amount, setAmount] = useState(0)
  const [amountType, setAmountType] = useState('full')
  const [showConfirm, setShowConfirm] = useState(false)
  const [detail, setDetail] = useState(undefined as GrnData | undefined)
  useEffect(() => {
    if (!visible) {
      setAmount(0)
      setAmountType('full')
    }
  }, [visible])

  useEffect(() => {
    setDetail(cloneDeep(grn))
  }, [grn])

  useEffect(() => {
    if (amountType === 'full') {
      setAmount(depy_amount)
    }
  }, [visible, amountType, depy_amount])

  const onUpdateAmount = (val: any) => {
    let newAmount = parseFloat(val)
    if (newAmount > depy_amount) {
      newAmount = depy_amount
    }
    setAmount(newAmount)
    if (detail) {
      setDetail({ ...detail, total_recieve_price: newAmount })
    }
  }

  const renderConfirmInfo = () => {
    return (
      <ConfirmWrapper>
        <Row gutter={[8, 16]}>
          <Col span={24}>
            <Row justify="space-between" align="middle" gutter={[32, 8]}>
              <Col>
                <Space>
                  ยอดที่ต้องชำระ <Price>{numberWithComma(depy_amount, true)}</Price> บาท
                </Space>
              </Col>
              <Col>
                <Radio.Group value={amountType} onChange={e => setAmountType(e.target.value)}>
                  <Radio.Button value="full">ชำระเต็มจำนวน</Radio.Button>
                  <Radio.Button value="patial">แบ่งชำระ</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <AppInput
              name="price_c"
              label={''}
              isRequired={true}
              isError={false}
              value={amount}
              onChange={onUpdateAmount}
              type="number"
              resProps={{ suffix: 'บาท', disabled: amountType === 'full' }}
            />
          </Col>
        </Row>
      </ConfirmWrapper>
    )
  }

  const ConfirmPatialModal = (
    <ConfirmPayDept
      onCloseModal={() => setShowConfirm(false)}
      onConfirm={() => {
        setShowConfirm(false)
        onConfirm(amount)
      }}
      visible={showConfirm}
      supplier={detail?.supplier}
      grnList={detail ? [detail] : []}
    />
  )

  return (
    <>
      {ConfirmPatialModal}
      <ConfirmWithChild
        title={'ระบุจำนวนเงินที่ต้องการชำระ'}
        isShow={visible}
        handleOk={() => setShowConfirm(true)}
        handleCancel={onCloseModal}
        child={renderConfirmInfo()}
        cancelBtnTxt="ยกเลิก"
        confirmBtnTxt="ยืนยันชำระหนี้"
        width={'50%'}
      />
    </>
  )
}

const Price = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title1};
`
const ConfirmWrapper = styled.div`
  padding: 10px;
  text-align: left;
`

export default AmountPayDept
